/**
 * Recent searches cookie helper.
 * Stores up to the last N search queries for display in the header.
 */

const RECENT_SEARCHES_COOKIE = 'recentSearches'
/** Max items we show in the UI (e.g. in header). We store one extra so we can show this many when on search page and current query is excluded. */
export const RECENT_SEARCHES_DISPLAY_MAX = 3
const MAX_RECENT_STORED = RECENT_SEARCHES_DISPLAY_MAX + 1
const MAX_AGE_DAYS = 30

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? decodeURIComponent(match[2]) : null
}

function setCookie(name: string, value: string, days: number): void {
  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
  document.cookie =
    name + '=' + encodeURIComponent(value) + ';path=/;expires=' + expires.toUTCString() + ';SameSite=Lax'
}

/**
 * Returns the list of recent search terms (newest first), or empty array.
 */
export function getRecentSearches(): string[] {
  try {
    const raw = getCookie(RECENT_SEARCHES_COOKIE)
    const list = raw ? JSON.parse(raw) : []
    return Array.isArray(list) ? list : []
  } catch {
    return []
  }
}

/**
 * Appends a search query to recent searches (deduped, max MAX_RECENT).
 * Call when the user lands on /search with a query.
 */
export function addRecentSearch(query: string): void {
  const trimmed = (query || '').trim()
  if (!trimmed) return

  try {
    let list = getRecentSearches()
    list = list.filter((q) => q !== trimmed)
    list.unshift(trimmed)
    list = list.slice(0, MAX_RECENT_STORED)
    setCookie(RECENT_SEARCHES_COOKIE, JSON.stringify(list), MAX_AGE_DAYS)
  } catch {
    // no-op
  }
}
